import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../../web/ReactQueryProvider';
import { timeEntryKeys } from './keys';
import { ITimeEntryDay, ITimeEntryPage } from './types';

export function useMyOverdueTimeEntriesQuery({ enabled = true }: { enabled?: boolean } = {}) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: timeEntryKeys.overdue(),
		queryFn: () =>
			userSession.webServiceHelper.callAsync<ITimeEntryPage<ITimeEntryDay>>('TimeEntry/mine/overdue', 'GET'),
		enabled,
		staleTime: 60_000,
		meta: {
			errorLogging: { action: 'MyOverdueTimeEntriesQuery-Error', category: 'TimeEntry' },
		} satisfies LevStandardQueryMeta,
	});
}
